import { render, staticRenderFns } from "./card-banner-sowhatbuy.vue?vue&type=template&id=7b11d19e&scoped=true&"
import script from "./card-banner-sowhatbuy.vue?vue&type=script&lang=js&"
export * from "./card-banner-sowhatbuy.vue?vue&type=script&lang=js&"
import style0 from "./card-banner-sowhatbuy.vue?vue&type=style&index=0&id=7b11d19e&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7b11d19e",
  null
  
)

export default component.exports